import script from "./DuyuruScreen2.vue?vue&type=script&setup=true&lang=js"
export * from "./DuyuruScreen2.vue?vue&type=script&setup=true&lang=js"

import "./DuyuruScreen2.vue?vue&type=style&index=0&id=8d6a5eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d6a5eae"]])

export default __exports__